import {CANVAS} from "../constants/configs";
import {isMobile} from "pixi.js";
import {store} from "../store";

const controlPanelHeight = isMobile.phone ? 320 : 77;

const desktopCpButtonSizeTypes = {
    btnSize1: {
        width: 40, height: 40,
    }, btnSize2: {
        width: 60, height: 60,
    }, spinBtn: {
        width: 130, height: 130,
    }
}

const mobileCpButtonSizeTypes = {
    btnSize1: {
        width: 50, height: 50,
    }, btnSize2: {
        width: 75, height: 75,
    }, spinBtn: {
        width: 150, height: 150,
    }
}

const cpButtonSizeTypes = isMobile.phone ? mobileCpButtonSizeTypes : desktopCpButtonSizeTypes;

const config = {
    width: CANVAS.width,
    height: controlPanelHeight,
    y: CANVAS.height - controlPanelHeight,
    ...cpButtonSizeTypes,
}

const desktopBtnConfigs = {
    historyBtn: {
        textureName: "historyBtn.png",
        x: 35,
        y: -50,
        width: config.btnSize1.width,
        height: config.btnSize1.height
    },
    soundSwitcherBtn: {
        textureName: store.isSoundOff ? "muteSound.png": "sound.png",
        x: 35,
        y: 50,
        width: config.btnSize1.width,
        height: config.btnSize1.height
    },
    infoBtn: {
        textureName: "info.png",
        x: 35,
        y: 0,
        width: config.btnSize1.width,
        height: config.btnSize1.height
    },
    amountBtn: {
        textureName: "amount.png",
        x: 1130,
        y: (config.height) / 2,
        width: config.btnSize2.width,
        height: config.btnSize2.height
    },
    autoSpinBtn: {
        textureName: "autoSpin.png",
        x: 1320,
        y: (config.height) / 2,
        width: config.btnSize2.width,
        height: config.btnSize2.height
    },
    spinBtn: {
        textureName: "spin.png",
        x: 1225,
        y: 0,
        width: config.spinBtn.width,
        height: config.spinBtn.height
    },
    stopSpinBtn: {
        textureName: "stopSpin.png",
        x: 1225,
        y: 0,
        width: config.spinBtn.width,
        height: config.spinBtn.height
    },
    stopAutoSpinContainer: {
        btn: {
            textureName: "stopSpin.png",
            x: 0,
            y: 0,
            width: config.spinBtn.width,
            height: config.spinBtn.height,
            fontSize: 42,
        },
        x: 1225,
        y: 0,
    },
}

const mobileBtnConfigs = {
    historyBtn: {
        textureName: "historyBtn.png",
        x: CANVAS.width - config.btnSize1.width/1.5,
        y: config.height - config.btnSize1.height*3,
        width: config.btnSize1.width,
        height: config.btnSize1.height
    },
    soundSwitcherBtn: {
        textureName: store.isSoundOff ? "muteSound.png": "sound.png",
        x: CANVAS.width - config.btnSize1.width/1.5,
        y: config.height - config.btnSize1.height/1.7,
        width: config.btnSize1.width,
        height: config.btnSize1.height
    },
    infoBtn: {
        textureName: "info.png",
        x: CANVAS.width - config.btnSize1.width/1.5,
        y: config.height - config.btnSize1.height*1.8,
        width: config.btnSize1.width,
        height: config.btnSize1.height
    },
    amountBtn: {
        textureName: "amount.png",
        x: (CANVAS.width/5)*1 +30,
        y: config.spinBtn.height/2.4,
        width: config.btnSize2.width,
        height: config.btnSize2.height
    },
    autoSpinBtn: {
        textureName: "autoSpin.png",
        x: (CANVAS.width/5)*4 -30,
        y: config.spinBtn.height/2.4,
        width: config.btnSize2.width,
        height: config.btnSize2.height
    },
    spinBtn: {
        textureName: "spin.png",
        x: CANVAS.width/2,
        y: config.spinBtn.height/2.4,
        width: config.spinBtn.width,
        height: config.spinBtn.height
    },
    stopSpinBtn: {
        textureName: "stopSpin.png",
        x: CANVAS.width/2,
        y: 0,
        width: config.spinBtn.width,
        height: config.spinBtn.height
    },
    stopAutoSpinContainer: {
        btn: {
            textureName: "stopSpin.png",
            x: 0,
            y: 0,
            width: config.spinBtn.width,
            height: config.spinBtn.height,
            fontSize: 45,
        },
        x: CANVAS.width/2,
        y: 0,
    },
}

const btnConfigs = isMobile.phone ? mobileBtnConfigs : desktopBtnConfigs;

export const cpConfigs = {
    ...config,
    ...btnConfigs,
}